import React from 'react';

function NoMatch() {
    return (
        <h1>Error 404</h1>
    );
}

export default NoMatch;